import React from "react";

import "./DelegationInProgressItem.scss";
import moment from "moment";

const DelegationInProgressItem = (
    {
        listItem,
        setState,
        setStateModel,
        field,
        itemClickHandler,
        property,
    }
) => {

    function selectHandler (event, listItem) {
        setState(() => listItem[property ? property : "substitute"].fullName);
        setStateModel((prev) => {
            return {
                ...prev,
                [field]: listItem.id,
            };
        });

        itemClickHandler(event, listItem);
    }

    return (
        <div
            className={"delegation-in-progress-item"}
            onClick={(event) => selectHandler(event, listItem)}>
            <div  className={"delegation-in-progress-item__fullname"}>
                {listItem[property ? property : "substitute"].fullName}
            </div>
            <div className={"delegation-in-progress-item__info"}>
                <div className={"delegation-in-progress-item__info__dates"}>
                    <div>{moment(listItem.from).format("DD.MM.YYYY")}</div>
                    {listItem.to ? "-" : ""}
                    <div>{listItem.to ? moment(listItem.to).format("DD.MM.YYYY") : ""}</div>
                </div>
                {/*<div className={"delegation-in-progress-item__info__comment"}>*/}
                {/*    {listItem.comment}*/}
                {/*</div>*/}
            </div>
        </div>
    );
};

export default DelegationInProgressItem;
